export default {
    label: "Tasks",
    page_title: "Tasks",
    list_subtitle: "Task list",
    filter: "Filter",
    close: "Close",
    description: "Description",
    description_placeholder: "Add a detailed description...",
    title_placeholder: "Task name...",
    automation_prefix: "Automation: ",
    created_by: "Task created by: {0}",
    created_by_automation: "Task created by: automation {0}",
    created_by_label: "Created by",
    automation_source: "automation {0}",
    form_response: "Form response",
    col_name: "Name",
    col_board: "Board",
    col_stage: "Stage",
    col_assignee: "Assignee",
    col_client: "Client",
    col_group: "Board",
    col_status: "Status",
    col_due_date: "Due date",
    col_priority: "Priority",
    no_date: "No date",
    complete: "Complete",
    reopen: "Reopen",
    status_pending: "Pending",
    status_in_progress: "In progress",
    status_completed: "Completed",
    status_archived: "Archived",
    priority_normal: "Medium",
    add: "Add",
    add_new_task: "Add new task",
    add_task_short: "Add",
    batch_actions: "Batch actions",
    batch_actions_short: "Actions",
    change_deadline: "Change Deadline",
    change_deadline_batch: "Change deadline in batch",
    export: "Export",
    export_tasks: "Export tasks",
    archive: "Archive",
    mark_as_completed: "Mark as completed",
    tasks_count: "{0} tasks",
    tasks_count_of_total: "{0} of {1}",
    no_tasks_found: "No tasks found!",
    archived_badge: "Archived",
    completed_badge: "Completed",
    back: "Back",
    task_archived_status: "Task archived",
    task_already_completed: "Task already completed",

    confirm_archive_batch_title: "Are you sure you want to archive {0} tasks?",
    confirm_archive_batch_body: "This action will archive all tasks matching the current filter.",
    confirm_complete_all_title: "Are you sure you want to mark {0} tasks as completed?",
    confirm_complete_all_body: "This action will mark as done all tasks matching the current filter.",
    confirm_batch_deadline_body: "This action will change the deadline of all tasks in the current filter to the date below.",
    new_deadline: "New deadline",
    confirm_complete_task_title_before: "Are you sure you want to mark the task",
    confirm_complete_task_title_after: "as completed?",
    confirm_complete_task_body: "This task will be marked as completed after confirmation.",
    confirm_archive_task_title_archive: "Are you sure you want to archive the task",
    confirm_archive_task_title_restore: "Are you sure you want to restore the task",
    confirm_archive_task_body_archived: "This task will be archived after confirmation.",
    confirm_archive_task_body_restored: "This task will be restored after confirmation.",
    confirm_delete_note_title: "Are you sure you want to delete this comment?",
    confirm_delete_note_body: "This action cannot be undone.",

    priority: "Priority",
    task_priority: "Task priority",
    priority_undefined: "Undefined",
    priority_low: "Low",
    priority_medium: "Medium",
    priority_high: "High",
    deadline: "Deadline",
    not_defined: "Not defined",
    assignee: "Assignee",
    requester: "Requester",
    task_assignee: "Task assignee",
    client: "Client",
    integration_id: "Integration Id:",
    view_profile: "View profile",
    order: "Sale",
    quotation: "Quotation",
    view_on_client: "View on client",
    feedback: "Answer",
    linked_answer: "Linked answer",
    linked_answer_placeholder: "Select an answer",
    linked_answer_none: "None",
    linked_answer_help: "Link a client answer to this task.",
    linked_answer_need_client: "Select a client to link an answer.",
    open_answer: "Open answer",
    average: "Average:",
    attachments_title: "Attachments",
    attachments_empty: "No files attached",
    attachments_upload: "Add files",
    attachments_uploading: "Uploading...",
    attachments_delete: "Remove attachment",
    notify_file_uploaded: "File(s) attached",
    notify_file_upload_error: "Could not attach the file",
    notify_file_deleted: "Attachment removed",
    notify_file_delete_error: "Could not remove the attachment",
    notify_answer_linked: "Answer linked",
    notify_answer_link_error: "Could not link the answer",
    board: "Board",
    task_board: "Task board",
    none: "None",
    automation: "Automation",
    creation_date: "Creation date",
    completed_at: "Completed at",

    client_not_subscribed_whatsapp: "The client has not allowed receiving messages via WhatsApp.",
    suggested_message: "Suggested message:",
    send_via_whatsapp: "Send via WhatsApp",
    send_via_email: "Send via E-mail",

    notes_title: "Comments",
    note_placeholder: "Write here what you did or plan to do regarding this task",
    add_note: "Comment",
    save: "Save",
    cancel: "Cancel",
    edit_note: "Edit comment",
    delete_note: "Delete comment",
    edit_note_text: "Edit comment text",
    new_note: "New comment",
    edit_task: "Edit task",
    archive_task: "Archive task",

    notify_task_completed: "Task completed!",
    notify_task_reopened: "Task reopened!",
    notify_error_update: "Error updating task",
    notify_task_archived: "Task archived!",
    notify_task_unarchived: "Task unarchived!",
    notify_tasks_archived: "{0} tasks archived!",
    notify_tasks_completed: "{0} tasks completed!",
    notify_deadlines_updated: "{0} deadlines updated!",
    notify_note_saved: "Comment saved successfully",
    notify_note_updated: "Comment updated successfully",
    notify_note_deleted: "Comment deleted successfully",
    notify_note_empty: "The comment cannot be empty",
    notify_error_update_note: "Error updating comment",
    notify_error_delete_note: "Error deleting comment",
    notify_error_load_more: "Error loading more tasks",
    notify_error_load: "Error loading tasks",
    notify_task_saved: "Task saved successfully",

    filter_automation: "Automation",
    filter_status: "Status",
    filter_status_pending: "Pending",
    filter_status_completed: "Completed",
    filter_status_archived: "Archived",
    filter_assignee: "Assignee",
    filter_task_due_date: "Task deadline",
    filter_creation_date: "Creation date",
    filter_tags: "Tag",
    notify_tag_error: "Could not update the tag",

    form: {
        title_label: "Title",
        assignee: "Assignee",
        deadline: "Deadline",
        client: "Client",
        description: "Description",
        suggested_message: "Message suggestion",
        cancel: "Cancel",
        save: "Save",
        days: "Sun,Mon,Tue,Wed,Thu,Fri,Sat",
        months: "Jan,Feb,Mar,Apr,May,Jun,Jul,Aug,Sep,Oct,Nov,Dec",
        apply: "Apply",
    },

    select_board: "Select board",
    create_board: "Create board",
    create_board_action: "Create",
    board_name_placeholder: "Board name",
    switch_to_board: "Board view",
    switch_to_list: "List view",
    create_task_title: "New task",
    create_more: "Create more",
    create_task_stage_placeholder: "Stage",
    create_task_title_required: "Enter a task title",
    create_task_action: "Create task",
    no_boards: "No boards found",
    no_board_option: "No board",
    delete_board: "Delete board",

    boards: {
        board_title: "Board:",
        task_details: "Task details",
        add_task_placeholder: "Add task...",
        complete_column: "Complete",
        complete_drop_hint: "Drop here to complete",
        empty_column: "No tasks",
        new_column: "New column",
        confirm_archive_board_title_before: "Are you sure you want to archive the board",
        confirm_archive_board_body: "This board will be archived after confirmation.",
        new_board_placeholder: "New board...",
        notify_board_archived: "Board archived successfully!",
        notify_board_created: "Board created successfully!",
        quotation_total: "Quotations (total):",
        quotation_drafts: "Drafts:",
        quotation_sent: "Sent:",
        quotation_accepted: "Accepted:",
        quotation_rejected: "Rejected:",
        quotation_expired: "Expired:",
    },
};
